module.exports = __webpack_public_path__ + "img/lapiz.4fedf53f.gif";